import * as React from 'react';
import { Select, MenuItem, FormControl, InputLabel } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme: any) => ({
  formControl: {
    margin: theme.spacing.unit,
    width: '100%',
  },
});

class CheckboxField extends React.PureComponent<any, any> {
  public render() {
    const { field, value, onChange, classes } = this.props;
    return (
      <FormControl
        className={classes.formControl}
        key={field.field}
        required={field.required}
      >
        <InputLabel htmlFor={field.field}>{field.label}</InputLabel>
        <Select
          value={value}
          onChange={onChange}
          inputProps={{
            name: field.field,
            id: field.field,
          }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {field.options.map((option: string) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
}

export default withStyles(styles)(CheckboxField);



// WEBPACK FOOTER //
// ./src/modules/subscription/components/SubscriptionConfig/DropdownField.tsx